import classNames from 'classnames';
import * as React from 'react';

import { ImageData } from '../../../data/model';
import SelectableRoundImage from '../../../shared/components/SelectableRoundImage/SelectableRoundImage';
import css from './OptionVariationThumbnail.css';

interface OptionVariationThumbnailProps extends React.DOMAttributes<{}> {
  isSelected?: boolean;
  image: ImageData;
  readonly?: boolean;
  className?: string;
  highlighted?: boolean;
  id?: string;
  removeHighlight?: () => void;
  onClick?: () => void;
}

const OptionVariationThumbnail = ({
  className,
  highlighted,
  removeHighlight,
  ...props
}: OptionVariationThumbnailProps) => {
  const finalClassName = classNames(highlighted && css.scrolled, className);

  // Auto-clear the highlight 500ms after it is set.
  React.useEffect(() => {
    if (!highlighted) {
      return;
    }
    const timer = setTimeout(() => removeHighlight(), 500);
    return () => clearTimeout(timer);
  }, [highlighted]);

  return <SelectableRoundImage className={finalClassName} {...props} />;
};

export default OptionVariationThumbnail;
